const SavingMoneyChallenge2InitialText ="It seems as though everyone likes to give advice " +
    "about saving money.  Although there are no firm rules, there are some guidelines " +
    "that will lead to a good savings strategy.  Review the items in the 'Savings Advice' column. " +
    "If the advice sounds like a good idea, move it to the 'Advice that is Good' column. " +
    "If the advice does not seem like it is a good idea, move it to the 'Advice that is Not Good' " +
    "column. When you are done, click the 'Done' button."

export default SavingMoneyChallenge2InitialText 
